import { Component, computed } from '@angular/core';
import { DialogType } from 'src/app/models/dialog-mode.model';
import { LandmarkBinderMenuService } from '@/services/app/binder-menu.service';
import { MenubarModule } from 'primeng/menubar';
import { ChipModule } from 'primeng/chip';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';
import { SkeletonModule } from 'primeng/skeleton';
import { ProgressBarModule } from 'primeng/progressbar';
import { CommonModule, NgIf } from '@angular/common';
import { Tooltip } from 'primeng/tooltip';
import { UserAccessService } from '@/services/app/user-access.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { AppStateService } from '@/services/app/app-state.service';
import { BinderService } from '@/services/api/binder.service';
import { DocStateService } from '@/services/api/doc-state.service';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { BinderLockComponent } from './binder.lock.component';

@Component({
    selector: 'app-binder-menu',
    imports: [MenubarModule, ChipModule, BadgeModule, SkeletonModule, ProgressBarModule, CommonModule, NgIf, Tooltip, OverlayBadgeModule, ButtonModule, TagModule, BinderLockComponent],
    template: `
    <p-menubar *ngIf="currentBinderService.currentBinder()" [model]="landmarkBinderMenuService.binderMenu()" class="surface-card border-round shadow-2 mb-3">
    <ng-template pTemplate="end">
        <div class="layout-topbar">
        <ng-template #lockTooltipContent>
            <div class="flex align-items-center">
                <span>You do not have access to this binder.</span>
            </div>
        </ng-template>
        <p-button class="mr-2" *ngIf="!needsRegeneration" label="Docs Synced" icon="pi pi-check" tooltipPosition="bottom" [severity]="needsRegeneration ? 'danger' : 'secondary'" [pTooltip]="syncTooltipContent" (click)="toggleDocs()"/>
            <p-button class="ml-1 mr-2" *ngIf="needsRegeneration" label="Docs Outdated" icon="pi pi-file-pdf" tooltipPosition="bottom"  [badge]="docLength.toString()" [severity]="needsRegeneration ? 'danger' : 'secondary'" [pTooltip]="syncTooltipContent" (click)="toggleDocs()"/>
        <ng-template #syncTooltipContent>
            <div *ngIf="!needsRegeneration" class="flex align-items-center">
                <span>All PDFs are up to date</span>
            </div>
            <div *ngIf="needsRegeneration" class="unsynced-docs-container">
                <div class="info-text">Some Pdfs are out of date:</div>
                <div class="m-1 text-left" *ngFor="let doc of docStateService.templatesNeedingRegeneration()">
                    <p-chip label="{{docStateService.getTempalteById(doc.fileCategoryId, doc.selectedTemplateId)?.templateName}}" icon="pi pi-file-pdf"></p-chip>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="item" let-item let-root="root">
            <a pRipple class="flex align-items-center p-menuitem-link">
                <span [class]="item.icon"></span>
                <span class="ml-2">{{ item.label }}</span>
                <p-badge *ngIf="item.badge" [ngClass]="{ 'ml-auto': !root, 'ml-2': root }" [value]="item.badge" />
                <span *ngIf="item.shortcut" class="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{{ item.shortcut }}</span>
                <i *ngIf="item.items" [ngClass]="['pi', root ? 'pi-angle-down ml-2' : 'pi-angle-right ml-auto']"></i>
            </a>
        </ng-template>
        <app-binder-lock></app-binder-lock>
        </div>
    </ng-template>
</p-menubar>
    `
})
export class BinderMenuComponent {

  constructor(
    public userAccessService: UserAccessService,
    public appStateService: AppStateService,
    public currentBinderService: BinderService,
    public binderDialogService: BinderDialogService,
    public landmarkBinderMenuService: LandmarkBinderMenuService,
    public docStateService: DocStateService
  ) {
}

toggleDialog(header: string, type: DialogType) {
  this.binderDialogService.toggleDrawer(type, header, true);
}

get needsRegeneration() {
    return this.docStateService.templatesNeedingRegeneration().length > 0;
}

get docLength() {
    return this.docStateService.templatesNeedingRegeneration().length || 0;
}

toggleUnlock() {

}

toggleDocs() {
    this.binderDialogService.toggleDrawer('docs', 'Files', true);
    console.log('regen docs', this.docStateService.templatesNeedingRegeneration());
    console.log('categories', this.docStateService.categories);
}

}
